import { render, staticRenderFns } from "./GuideHeader.vue?vue&type=template&id=507fc812&scoped=true&"
import script from "./GuideHeader.vue?vue&type=script&lang=js&"
export * from "./GuideHeader.vue?vue&type=script&lang=js&"
import style0 from "./GuideHeader.vue?vue&type=style&index=0&id=507fc812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507fc812",
  null
  
)

export default component.exports